"use client";
import { LiveSharePage } from "@highway/design-system";

export default function LiveShare() {
    return (
        <>
            <title>Loan Comparison</title>
            <LiveSharePage
                tool="lc2"
                baseUrl="loan-compare"
                renderHeaderText={({ clientName }) => `Loan Comparison for ${clientName}`}
                renderButtonText={() => "View loan options"}
                hasReportRoute
            />
        </>
    );
}
